
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1suft_97",
  "button": "awsui_button_vjswe_1suft_101",
  "variant-normal": "awsui_variant-normal_vjswe_1suft_152",
  "is-activated": "awsui_is-activated_vjswe_1suft_165",
  "variant-icon": "awsui_variant-icon_vjswe_1suft_195",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1suft_195",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1suft_195",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1suft_216",
  "disabled": "awsui_disabled_vjswe_1suft_237",
  "variant-primary": "awsui_variant-primary_vjswe_1suft_245",
  "variant-link": "awsui_variant-link_vjswe_1suft_338",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1suft_617",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1suft_900",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1suft_998",
  "button-no-text": "awsui_button-no-text_vjswe_1suft_1091",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1suft_1095",
  "full-width": "awsui_full-width_vjswe_1suft_1098",
  "icon-left": "awsui_icon-left_vjswe_1suft_1117",
  "icon-right": "awsui_icon-right_vjswe_1suft_1122",
  "icon": "awsui_icon_vjswe_1suft_1117"
};
  